// constants for global design templates to CSS-in-JS (e.g. @material-ui useStyles hook)

export const designConstants = {
  color: {
    $black_full: '#000000',
    $black_33: '#333333',
    $blue_base: '#5da0c5',
    $blue_dark: '#396279',
    $green_base: '#35ab8c',
    $green_dark: '#26846b',
    $grey_4a: '#4a4a4a',
    $grey_6a: '#6a6a6a',
    $grey_82: '#828282',
    $grey_e6: '#e6e6e6',
    $red_base: '#eb5757',
    $red_dark: '#dc2626',
    $red_dark_second: '184, 23, 23',
    $teal_base: '0, 167, 157',
    $teal_light: '#76c9c4',
    $teal_bright: '0, 192, 181',
    $green_bright: '151, 228, 145',
    $teal_extralight: '#f5f8f9',
    $white_full: '#ffffff',
    $purple_light: '#e1ddff',
    $purple_dark: '#6f61d4',
    $orange: '255, 147, 48',
    $yellow: '243, 190, 1',
    $yellow_light: '255, 199, 0',
    $yellow_dark: '#b97c20',
    $purple: '69, 58, 148',
  },
};

// Button roles, as identified in the design palette (e.g. primary, dashboard, etc)
// refer to design colors as articulated in the designConstants color.file
export const buttonBaseStyles = {
  root: {
    borderRadius: 0,
    cursor: 'pointer',
    color: designConstants.color.$white_full,
    display: 'inline-block',
    fontSize: 16,
    fontWeight: 600,
    height: 40,
    margin: 0,
    width: 240,
    '&:disabled': { background: designConstants.color.$grey_e6 },
  },
  primary: {
    background: designConstants.color.$green_base,
    '&:hover': { background: designConstants.color.$green_dark },
  },
  secondary: {
    border: `2px solid ${designConstants.color.$grey_82}`,
    backgroundColor: designConstants.color.$white_full,
    color: designConstants.color.$grey_6a,
    '&:hover': {
      background: designConstants.color.$grey_4a,
      color: designConstants.color.$white_full,
    },
  },
  negative: {
    background: designConstants.color.$red_base,
    '&:hover': { background: designConstants.color.$red_dark },
  },
  dashboard: {
    background: designConstants.color.$blue_base,
    '&:hover': { background: designConstants.color.$blue_dark },
  },
  graphInfo: {
    background: 'transparent',
  },
};
